import { Tooltip } from "@tecsinapse/cortex-react";
import "react";
import { jsx } from "react/jsx-runtime";
//#region src/modules/core/components/header-tooltip.tsx
var HeaderTooltip = ({ children, style, ...props }) => {
	return /* @__PURE__ */ jsx(Tooltip, {
		...props,
		style: {
			zIndex: 700,
			...style
		},
		children
	});
};
//#endregion
export { HeaderTooltip };
